import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { isListedChannel, sortChannels, useChannels } from '../data/channels';
import { belongsToTeam, useActiveTeam } from '../data/teams';
import { useIsDesktop } from '../lib/media';

/**
 * Belepesi pont.
 *
 * ASZTALON az elso ertelmes csatornara ugrunk (altalanos, vagy a legfrissebb):
 * ott a lista amugy is latszik oldalt, tehat egy ures tartalom-oszlop csak
 * elpazarolt hely lenne.
 *
 * MOBILON viszont EZ a kezdolap: a bal oldali lap maga a csatorna- es
 * beszelgeteslista, es a felhasznalo abbol valaszt. Ha itt is atiranyitanank,
 * a lista soha nem latszana - a "vissza" gomb azonnal visszadobna egy
 * csatornaba.
 *
 * ─── A cel a NYITOTT CEGBOL valasztodik ─────────────────────────────────────
 *
 * Amig egyetlen ceg volt, egyetlen `#altalanos` is - a "keresd meg az
 * altalanost" tehat egyertelmu volt. Cegenkenti alapertelmezett csatornaval
 * viszont tobb is akad, es a szuretlen lista elso talalata barmelyike lehet:
 * aki vendegkent bent van egy masik ceg csatornajaban, azt az indulas ATVITTE
 * abba a cegbe - a cegvalto pedig kovette a megnyitott csatornat, tehat a
 * sajat cege csendben eltunt alóla.
 *
 * Ezert a valasztas a nyitott cegre szukitett listabol tortenik. Ha abban
 * nincs semmi, INKABB NEM ugrunk sehova: egy ures tartalom-oszlop kellemetlen,
 * de egy masik ceg beszelgetese rosszabb.
 */
export function HomeRoute() {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const { data: channels, isLoading } = useChannels();
  const { activeTeamId } = useActiveTeam();

  useEffect(() => {
    if (!isDesktop || !channels || channels.length === 0) return;

    const sajatCeg = channels.filter((c) => belongsToTeam(c, activeTeamId) && isListedChannel(c));
    const general = sajatCeg.find((c) => c.isGeneral);
    const target = general ?? sortChannels(sajatCeg)[0];

    if (target)
      void navigate({ to: '/c/$channelId', params: { channelId: target.id }, replace: true });
  }, [isDesktop, channels, activeTeamId, navigate]);

  return (
    <div className="grid h-full place-items-center px-6 text-center text-sm text-ink-muted">
      {isLoading ? 'Betöltés…' : 'Válassz egy beszélgetést.'}
    </div>
  );
}
